module.exports = __webpack_public_path__ + "img/collaborationIMG.253b48d8.png";